import { equals, keys, pick } from 'ramda';

export const match = <T extends Record<symbol, unknown>>(p: Partial<T>) => (
  o: T
) => equals(p, pick(keys(p), o) as Partial<T>);
